import { Icon } from "@iconify/react";
import React, { useState } from "react";
import AdminDoctorDetailsModal from "./AdminDoctorDetailsModal";
import { Link } from "react-router-dom";

const AdminAllDoctorsTable = ({ doctor, onUpdate }) => {
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  function closeModal() {
    setSelectedDoctor(null);
    if (onUpdate) onUpdate(); // Refresh counts and lists when modal closes
  }

  function openModal(doctor) {
    setSelectedDoctor(doctor);
  }

  return (
    <>
      <tr className="hover:bg-slate-50/50 transition-colors duration-150">
        {/* Name */}
        <td className="h-14 px-6 text-sm font-bold text-slate-700 capitalize">
          {capitalizeFirstLetter(doctor.name)}
        </td>

        {/* Email */}
        <td className="h-14 px-6 text-xs font-semibold text-slate-500">
          {doctor.email}
        </td>

        {/* Role */}
        <td className="h-14 px-6 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
          {capitalizeFirstLetter(doctor.role)}
        </td>

        {/* Status */}
        <td className="h-14 px-6 text-xs">
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full font-bold text-[10px] tracking-wide uppercase ${
              doctor?.isActive
                ? "bg-green-50 text-green-600"
                : "bg-red-50 text-red-500"
            }`}
          >
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                doctor?.isActive ? "bg-green-600" : "bg-red-500"
              }`}
            ></span>
            {doctor?.isActive ? "Active" : "Inactive"}
          </span>
        </td>

        {/* Actions */}
        <td className="h-14 px-6 text-right">
          <div className="inline-flex items-center gap-2">
            {/* View Patients */}
            <Link
              to={`/adminDashboard/doctorsPatient/${doctor._id}`}
              className="p-1.5 border border-slate-200 text-slate-500 hover:text-secondary hover:border-secondary hover:bg-indigo-50/30 rounded-lg transition duration-150"
              title="View Patients"
            >
              <Icon icon="solar:users-group-two-rounded-bold-duotone" className="text-base" />
            </Link>

            {/* Edit / Manage Details */}
            <button
              onClick={() => openModal(doctor)}
              className="p-1.5 border border-slate-200 text-slate-500 hover:text-secondary hover:border-secondary hover:bg-indigo-50/30 rounded-lg transition duration-150 cursor-pointer"
              title="Configure Details & Licenses"
            >
              <Icon icon="solar:pen-new-square-bold-duotone" className="text-base" />
            </button>
          </div>
        </td>
      </tr>

      {selectedDoctor && (
        <AdminDoctorDetailsModal
          closeModal={closeModal}
          isOpen={selectedDoctor !== null}
          doctor={selectedDoctor}
          doctorId={selectedDoctor._id}
        />
      )}
    </>
  );
};

export default AdminAllDoctorsTable;
